import React from "react";
import { Subwindow } from "../../../layout/Subwindow/Subwindow";
import { DashboardConfigMain } from "./DashboardConfigMain";

export const DashboardConfig = () => {

    return (

        <Subwindow
            headerSettings={false}
            isSingle={true}
            title={'Dashboard config'}
            footer={<></>}
            mainColor="white"
            main={<DashboardConfigMain/>}
            isRelative
        />
    )
}